import React, {
    FC,
    useState,
} from "react";
import {
    Button,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import {AutocompleteGeneric} from "../table/AutocompleteGeneric";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {Locale} from "../../locales/Locale";
import {FilterRangeSlider} from "./FilterRangeSlider";

interface FiltersProps {
    makers: any[];
    models: any[];
    types: any[];
    selectedMaker: number | null;
    selectedModel: number | null;
    selectedType: number | null;
    setSelectedMaker: (value: number | null) => void;
    setSelectedModel: (value: number | null) => void;
    setSelectedType: (value: number | null) => void;
    resetFilters: () => void;
    handleFilter: () => void;
    minMaxCC: number[];
    setMinMaxCC: (value: number[]) => void;
    minMaxYear: number[];
    setMinMaxYear: (value: number[]) => void;
}

export const Filters: FC<FiltersProps> = ({
    makers,
    models,
    types,
    selectedMaker,
    selectedModel,
    selectedType,
    setSelectedMaker,
    setSelectedModel,
    setSelectedType,
    resetFilters,
    handleFilter,
    minMaxCC,
    setMinMaxCC,
    minMaxYear,
    setMinMaxYear,
}) => {
    const [openCCRange, setOpenCCRange] = useState(false);
    const [openYearRange, setOpenYearRange] = useState(false);
    const handleCCRangeClick = () => {
        setOpenCCRange(!openCCRange);
    };
    const handleYearRangeClick = () => {
        setOpenYearRange(!openYearRange);
    };
    const handleMinMaxCCChange = (newValue: number[]) => {
        setMinMaxCC(newValue);
    };
    const handleMinMaxYearChange = (newValue: number[]) => {
        setMinMaxYear(newValue);
    };
    return (
        <Grid container direction="column" spacing={2} sx={{p: 2}}>
            <Grid item>
                <AutocompleteGeneric
                    options={makers}
                    value={selectedMaker ?? null}
                    onChange={(newValue: string | number | null) => setSelectedMaker(newValue as number | null)}
                    label={IdlocaGeneric.maker}
                />
            </Grid>
            <Grid item>
                <AutocompleteGeneric
                    options={models}
                    value={selectedModel ?? null}
                    onChange={(newValue: string | number | null) => setSelectedModel(newValue as number | null)}
                    label={IdlocaGeneric.model}
                />
            </Grid>
            <Grid item>
                <AutocompleteGeneric
                    options={types}
                    value={selectedType ?? null}
                    onChange={(newValue: string | number | null) => setSelectedType(newValue as number | null)}
                    label={IdlocaGeneric.type}
                />
            </Grid>
            <Grid item>
                <Typography variant="subtitle1"><Locale localeId={IdlocaGeneric.engine_size}/></Typography>
            </Grid>
            <Grid item>
                <Button variant="outlined" onClick={handleCCRangeClick}>
                    {minMaxCC[0]} - {minMaxCC[1]} CC
                </Button>
                {openCCRange && (
                    <Grid container direction="column" spacing={2} sx={{paddingTop: 2}}>
                        <Grid item>
                            <TextField
                                label={<Locale localeId={IdlocaGeneric.min_cc}/>}
                                type="number"
                                value={minMaxCC[0]}
                                onChange={(e) => setMinMaxCC([Number(e.target.value), minMaxCC[1]])}
                                fullWidth
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label={<Locale localeId={IdlocaGeneric.max_cc}/>}
                                type="number"
                                value={minMaxCC[1]}
                                onChange={(e) => setMinMaxCC([minMaxCC[0], Number(e.target.value)])}
                                fullWidth
                            />
                        </Grid>
                        <Grid item>
                            <FilterRangeSlider value={minMaxCC} onChange={handleMinMaxCCChange} min={50} max={2000}
                                step={50}/>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <Grid item>
                <Typography variant="subtitle1"><Locale localeId={IdlocaGeneric.year_range}/></Typography>
            </Grid>
            <Grid item>
                <Button variant="outlined" onClick={handleYearRangeClick}>
                    {minMaxYear[0]} - {minMaxYear[1]} Year
                </Button>
                {openYearRange && (
                    <Grid container direction="column" spacing={2} sx={{paddingTop: 2}}>
                        <Grid item>
                            <TextField
                                label={<Locale localeId={IdlocaGeneric.year_from}/>}
                                type="number"
                                value={minMaxYear[0]}
                                onChange={(e) => setMinMaxYear([Number(e.target.value), minMaxYear[1]])}
                                fullWidth
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label={<Locale localeId={IdlocaGeneric.year_to}/>}
                                type="number"
                                value={minMaxYear[1]}
                                onChange={(e) => setMinMaxYear([minMaxYear[0], Number(e.target.value)])}
                                fullWidth
                            />
                        </Grid>
                        <Grid item>
                            <FilterRangeSlider value={minMaxYear} onChange={handleMinMaxYearChange} min={1900}
                                max={2025} step={1}/>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <Grid item
                sx={{
                    display: "flex",
                    gap: 2,
                }}>
                <Button variant="outlined" onClick={resetFilters}
                    sx={{
                        backgroundColor: theme => theme.palette.button.secondary,
                        color: theme => theme.palette.button.text,
                        "&:hover": {
                            backgroundColor: theme => theme.palette.button.hover,
                        },
                    }}>
                    <Locale localeId={IdlocaGeneric.reset_button}/>
                </Button>
                <Button variant="contained" onClick={handleFilter}
                    sx={{
                        backgroundColor: theme => theme.palette.button.primary,
                        color: theme => theme.palette.button.text,
                        "&:hover": {
                            backgroundColor: theme => theme.palette.button.hover,
                        },
                    }}>
                    <Locale localeId={IdlocaGeneric.filter_button}/>
                </Button>
            </Grid>
        </Grid>
    )
        ;
};
export default Filters;
